export default "__VITE_ASSET__c205bb0e__"